import React, {useContext, useEffect, useState} from 'react';
import './Alarm.scss'
import {useNavigate} from "react-router-dom";
import mqttRequests from "../../Utils/mqttRequests";
import {MqttClientContext} from "../../context/MqttClientContext";
import {UserInfoContext} from "../../context/UserInfoContext";
import {Alert, Snackbar, Switch} from "@mui/material";
import moment from "moment";
import {SettingsContext} from "../../context/SettingsContext";
import AlarmHPicto from "../../assets/AlarmHPicto.gif";
import Accordion from "react-bootstrap/Accordion";
import visible from "../../assets/visible.png";

//the page with all the alarms
function GetAlarms(props) {

    const setMenuClicked = props.setMenuClicked;
    setMenuClicked('alarms');

    //back button effect
    window.addEventListener('popstate', () => {
        navigate("/")
    }, false);

    //to navigate through the app
    let navigate = useNavigate();

    let [pending, setPending] = useState(true);

    //to display popups
    const [successOpen, setSuccessOpen] = useState(false);
    const [errTwoOpen, setErrTwoOpen] = useState(false);

    //set variable to re get the data
    const [reshow, setReshow] = useState(false);

    //to contains data
    const [pendingAlarms, setPendingAlarms] = useState([]);
    const [oldAlarms, setOldAlarms] = useState([]);

    //the mqtt client and source
    const {mqttClient, source} = useContext(MqttClientContext);

    //the idAccount for mqtt
    const {idAccount} = useContext(UserInfoContext);
    const {idUser} = useContext(UserInfoContext);

    //the temperature unit from the settings
    const {temperatureUnit} = useContext(SettingsContext);

    //method to communicate with mqtt
    useEffect(() => {
        if(source !==null){
            //generate operation code
            const operation = mqttRequests.generateOperationCode("getAllAlarms");
            //create json to publish
            const data = '{"operation":"' + operation + '", "source":"' + source + '", "idAccount":"' + idAccount + '", "idUser":"' + idUser + '"}';

            //subscribe to the channel to wait for the mqtt response
            mqttRequests.subscribe(mqttClient, "source/" + source + "/getAllAlarms");
            //publish a demand to get all the alarms
            mqttRequests.publish(mqttClient, "alarm/getAllAlarms", data);


            //read incoming message and send response to a function to refactor them
            mqttRequests.incomingMessage((message) => {
                let jsonParsed = JSON.parse(message.toString());
                //if it has alarms, it's to load data
                if(jsonParsed.alarms){
                    if(jsonParsed.result===1){
                        refactorData(jsonParsed.alarms);
                    }
                //else, it's to release the alarm
                }else if(jsonParsed.result){
                    if(jsonParsed.result === 1){
                        setSuccessOpen(true);
                        setReshow(!reshow);
                    }else {
                        setErrTwoOpen(true);
                    }
                }
            })
        }
    },[source, mqttClient, idAccount, reshow]);

    //set the data ready to display
    const refactorData = (data) => {
        if(data.length !== 0){
            //get all the alarms in an array
            data = data.sort((a,b) => a.nameMission > b.nameMission ? 1 : -1);
            let tempOld = [];
            let tempPending = [];

            //sort alarms if they are pending or not
            data.forEach((element)=> {
                if(element.acknowledge === "1"){
                    tempPending.push(element);
                }else {
                    tempOld.push(element);
                }
            })

            //prepare variables
            let tempSortedAlarm = [];
            let actualMissionName = "";
            let tempAlarmForMission = [];

            //create an array of array, each mission have an array with all its alarms (for pending alarms)
            if(tempPending.length !== 0){
                tempSortedAlarm = [];
                actualMissionName = tempPending[0].nameMission;
                tempAlarmForMission = [];
                tempPending.sort((a,b) => a.nameMission > b.nameMission ? 1 : -1).forEach((mission) => {
                    if(mission.nameMission === actualMissionName){
                        tempAlarmForMission.push(mission);
                    }else {
                        tempSortedAlarm.push(tempAlarmForMission);
                        tempAlarmForMission = [mission];
                        actualMissionName = mission.nameMission;
                    }
                })
                tempSortedAlarm.push(tempAlarmForMission);

                //set the variable for the display
                setPendingAlarms(tempSortedAlarm);
            }else{
                setPendingAlarms([]);
            }


            //create an array of array, each mission have an array with all its alarms (for old alarms)
            if(tempOld.length !== 0){
                tempSortedAlarm = [];
                actualMissionName = tempOld[0].nameMission;
                tempAlarmForMission = [];
                tempOld.sort((a,b) => a.nameMission > b.nameMission ? 1 : -1).forEach((mission) => {
                    if(mission.nameMission === actualMissionName){
                        tempAlarmForMission.push(mission);
                    }else {
                        tempSortedAlarm.push(tempAlarmForMission);
                        tempAlarmForMission = [mission];
                        actualMissionName = mission.nameMission;
                    }
                })
                tempSortedAlarm.push(tempAlarmForMission);

                //set the variable for the display
                console.log(tempSortedAlarm)


                setOldAlarms(tempSortedAlarm);
            }
        }
    }

    //to ask mqtt to release an alarm
    const handleRelease = (alarm) => {
        //generate operation code
        const operation = mqttRequests.generateOperationCode("releaseAlarm");
        //create json to publish
        const data = '{"operation":"' + operation + '", "source":"' + source + '", "idAlarm":"' + alarm.idAlarm + '", "idMissionSupervision":"' + alarm.idMissionSupervision + '"}';
        //subscribe to the channel to wait for the mqtt response
        mqttRequests.subscribe(mqttClient, "source/" + source + "/releaseAlarm");
        //publish a demand to get all the kinetics
        mqttRequests.publish(mqttClient, "alarm/releaseAlarm", data);
    }

    return(
        <div className="baseMainDiv">
            <div className="BaseTitleDiv">
                <img src={AlarmHPicto} alt="Picto" className="basePicto"/>
                <h2 className="baseTitle">ALARM HISTORY</h2>
            </div>
            <div className="baseSubmenu">
                <p className="baseSubmenuContent" onClick={() => setPending(true)}
                   style={{"background-color": pending===true ? "#d0cfd0" : "#E7E7E7",
                       "text-decoration": pending===true ? "underline" : "none",
                       "font-weight": pending===true ? "bold" : "normal"}}>Pending alarms</p>
                <p className="baseSubmenuContent" onClick={() => setPending(false)}
                   style={{"background-color": pending===false ? "#d0cfd0" : "#E7E7E7",
                       "text-decoration": pending===false ? "underline" : "none",
                       "font-weight": pending===false ? "bold" : "normal"}}>Old alarms</p>
            </div>
            <div className="basePageBody"></div>

            {pending === true ?
                pendingAlarms.length !== 0 ?
                    <Accordion alwaysOpen className="baseDivAccordion" defaultActiveKey={pendingAlarms.map((_, i) => i)} key="pending">
                        {pendingAlarms.sort((a,b) => a[0].nameMission > b[0].nameMission ? 1 : -1,).map(function (groupAlarms, id) {
                            return (
                                <div key={id}>
                                    <Accordion.Item eventKey={id}>
                                        <Accordion.Header>
                                            <span className="deviceSpan">
                                                <img className="deviceVisible" src={visible}/>
                                            </span>
                                            {groupAlarms[0].nameMission}</Accordion.Header>
                                        <Accordion.Body className="baseAccordionBody">
                                            <table className="alarmTable">
                                                <thead>
                                                <tr>
                                                    <th className="alarmTableTh" style={{"width":"20%"}}>ON DEVICE</th>
                                                    <th className="alarmTableTh" style={{"width":"20%"}}>DEVICE CONNECTED</th>
                                                    <th className="alarmTableTh" style={{"width":"10%"}}>KINETIC</th>
                                                    <th className="alarmTableTh" style={{"width":"20%"}}>TRIGGER</th>
                                                    <th className="alarmTableTh" style={{"width":"15%"}}>TRIGGER TIME</th>
                                                    <th className="alarmTableTh" style={{"width":"5%"}}>RELEASE</th>
                                                </tr>
                                                </thead>
                                                {groupAlarms.map((alarm, subId) => {
                                                    return (
                                                        <tbody key={subId}>
                                                        <tr className="alarmDivTxt">
                                                            <td className="alarmTableTd">
                                                                <h4 className="alarmTableText">{alarm.deviceName} ({alarm.deviceIdentifier})</h4>
                                                            </td>
                                                            <td className="alarmTableTd">
                                                                {alarm.gatewayIdentifier === "mv" || alarm.gatewayIdentifier === "external" || alarm.gatewayIdentifier === "gateway"?
                                                                    <p className="alarmTableText">The gateway</p>
                                                                    :
                                                                    alarm.gatewayIdentifier !== ""?
                                                                        <p className="alarmTableText">device connected: {alarm.gatewayIdentifier}</p>
                                                                        :
                                                                        <p className="alarmTableText">-</p>
                                                                }
                                                            </td>
                                                            <td className="alarmTableTd">
                                                                <p className="alarmTableText">-</p>
                                                            </td>
                                                            <td className="alarmTableTd">
                                                                {alarm.datatype !== "Crash" ?
                                                                    alarm.limiteType === 3 ?
                                                                        <p className="alarmTableText">The device did not send points during {alarm.limite} minutes</p>
                                                                        :
                                                                        <p className="alarmTableText">{alarm.datatype} {alarm.limiteType === 1? "greater than " : "lower than "}
                                                                            {alarm.datatype === "Temperature" ?
                                                                                temperatureUnit === "F" ?
                                                                                    (alarm.limite* 9 / 5) + 32
                                                                                    :
                                                                                    temperatureUnit === "K" ?
                                                                                        alarm.limite+273.15
                                                                                        :
                                                                                        alarm.limite
                                                                                :
                                                                                alarm.limite}
                                                                        </p>
                                                                    :
                                                                    <p className="alarmTableText">A crash has occurred</p>
                                                                }
                                                            </td>
                                                            <td className="alarmTableTd">
                                                                <p className="alarmTableText">{moment(new Date(alarm.dateAlarm*1000)).format("YYYY MMMM DD, HH:mm")}</p>
                                                            </td>
                                                            <td className="alarmTableTd">
                                                                <Switch size="small" id={alarm.idAlarm} onChange={() => handleRelease(alarm)} className="alarmSwitch"/>
                                                            </td>
                                                        </tr>
                                                        </tbody>
                                                    )
                                                })}

                                            </table>

                                        </Accordion.Body>
                                    </Accordion.Item>
                                </div>
                            )
                        })}
                    </Accordion>
                    :
                    <p className="alarmText">No pending alarms for the moment</p>
                :
                oldAlarms.length !== 0 ?
                    <Accordion alwaysOpen className="baseDivAccordion" key="old">
                        {oldAlarms.sort((a,b) => a[0].nameMission > b[0].nameMission ? 1 : -1,).map(function (groupAlarms, id) {
                            return (
                                <div key={id}>
                                    <Accordion.Item eventKey={id}>
                                        <Accordion.Header>
                                            <span className="deviceSpan">
                                                <img className="deviceVisible" src={visible}/>
                                            </span>
                                            {groupAlarms[0].nameMission}</Accordion.Header>
                                        <Accordion.Body className="baseAccordionBody">
                                            <table className="alarmTable">
                                                <thead>
                                                <tr>
                                                    <th className="alarmTableTh" style={{"width":"22.5%"}}>On device</th>
                                                    <th className="alarmTableTh" style={{"width":"22.5%"}}>device connected</th>
                                                    <th className="alarmTableTh" style={{"width":"10%"}}>Kinetic</th>
                                                    <th className="alarmTableTh" style={{"width":"25%"}}>Trigger</th>
                                                    <th className="alarmTableTh" style={{"width":"20%"}}>Trigger time</th>
                                                </tr>
                                                </thead>
                                                {groupAlarms.map((alarm, subId) => {
                                                    return (
                                                        <tbody key={subId}>
                                                        <tr className="alarmDivTxt">
                                                            <td className="alarmTableTd">
                                                                <h4 className="alarmTableText">{alarm.deviceName} ({alarm.deviceIdentifier})</h4>
                                                            </td>
                                                            <td className="alarmTableTd">
                                                                {alarm.gatewayIdentifier === "mv" || alarm.gatewayIdentifier === "external" || alarm.gatewayIdentifier === "gateway"?
                                                                    <p className="alarmTableText">The gateway</p>
                                                                    :
                                                                    alarm.gatewayIdentifier !== ""?
                                                                        <p className="alarmTableText">device connected: {alarm.gatewayIdentifier}</p>
                                                                        :
                                                                        <p className="alarmTableText">-</p>
                                                                }
                                                            </td>
                                                            <td className="alarmTableTd">
                                                                <p className="alarmTableText">-</p>
                                                            </td>
                                                            <td className="alarmTableTd">
                                                                {alarm.datatype !== "Crash" ?
                                                                    alarm.limiteType === 3 ?
                                                                        <p className="alarmTableText">The device did not send points during {alarm.limite} minutes</p>
                                                                        :
                                                                        <p className="alarmTableText">{alarm.datatype} {alarm.limiteType === 1? "greater than " : "lower than "}
                                                                            {alarm.datatype === "Temperature" ?
                                                                                temperatureUnit === "F" ?
                                                                                    (alarm.limite* 9 / 5) + 32
                                                                                    :
                                                                                    temperatureUnit === "K" ?
                                                                                        alarm.limite+273.15
                                                                                        :
                                                                                        alarm.limite
                                                                                :
                                                                                alarm.limite}
                                                                        </p>
                                                                    :
                                                                    <p className="alarmTableText">A crash has occurred</p>
                                                                }
                                                            </td>
                                                            <td className="alarmTableTd">
                                                                <p className="alarmTableText">{moment(new Date(alarm.dateAlarm*1000)).format("YYYY MMMM DD, HH:mm")}</p>
                                                            </td>
                                                        </tr>
                                                        </tbody>
                                                    )
                                                })}
                                            </table>
                                        </Accordion.Body>
                                    </Accordion.Item>
                                </div>
                            )
                        })}
                    </Accordion>
                    :
                    <p className="alarmText">No Alarms released for the moment</p>
            }
            <Snackbar open={successOpen} autoHideDuration={4000} onClose={() => setSuccessOpen(false)}
                      anchorOrigin={{vertical: 'top', horizontal: 'center'}} sx={{ mt: "20px"}}>
                <Alert severity="success">alarm successfully released</Alert>
            </Snackbar>
            <Snackbar open={errTwoOpen} autoHideDuration={4000} onClose={() => setErrTwoOpen(false)}
                      anchorOrigin={{vertical: 'top', horizontal: 'center'}} sx={{ mt: "20px"}}>
                <Alert severity="error">Error - Something went wrong</Alert>
            </Snackbar>
        </div>
    )
}

export default GetAlarms;